import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, Box, IconButton, Link, Typography } from "@mui/material";

import { Post } from "../../../types/types";
import { OptionIcon } from "../../../assets/icons/create-feed";
import { usePostFormatter } from "../../../hooks/usePostFormatter";

import PostCardMenu from "./PostCardMenu";

const PostCardHeader = ({
  post,
  isRepostedPost,
  isSharedPost,
}: {
  post: Post;
  isRepostedPost?: boolean;
  isSharedPost?: boolean;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();

  const { authorFullName, authorMedia, authorFirstTwoChr, authorRole, authorLink, timeAgo, authorId } =
    usePostFormatter(post);

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", padding: "16px 16px 0" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", gap: "8px" }}>
        <Avatar src={authorMedia} sx={{ width: 40, height: 40 }}>
          {authorFirstTwoChr}
        </Avatar>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Link
            sx={{
              color: "var(--Dark---1000, #111)",
              fontFamily: "Montserrat",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "24px",
              textDecoration: "unset",
              cursor: "pointer",
            }}
            onClick={() => navigate(authorLink)}
          >
            {authorFullName}
          </Link>
          {(authorRole || timeAgo) && (
            <Typography
              sx={{
                color: "var(--Dark---600, #707070)",
                fontFamily: "Montserrat",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "18px",
              }}
            >
              {authorRole}
              {authorRole && " . "}
              {timeAgo}
            </Typography>
          )}
        </Box>
      </Box>
      {/* {!Boolean(isRepostedPost) && (
        <> */}
      <IconButton onClick={(event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)}>
        <OptionIcon />
      </IconButton>
      <PostCardMenu
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        authorFullName={authorFullName}
        authorId={authorId}
        postId={post.id}
      />
      {/* </>
      )} */}
    </Box>
  );
};

export default PostCardHeader;
